import React from 'react';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { showLoader, showMessage, handleHTTPError, putAccessToken } from 'store/actions';
import { login } from 'apis';
import { validateEmail } from 'utils';
import CircularProgress from 'components/CircularProgress';
import TextBox from 'components/controls/TextBox';
import './index.scss';

class Login extends React.Component {
    constructor() {
        super();
        this.state = {
            showMsg: false,
            email: '',
            password: '',
            validate: false,
        };
    }

    componentDidMount() {}

    signIn = async () => {
        this.setState({ validate: true });
        if (!this.state.email || !validateEmail(this.state.email) || !this.state.password) return;
        try {
            const params = {
                email: this.state.email,
                password: this.state.password,
            };
            this.props.showLoader(true);
            const { access_token } = await login(params);
            this.props.putAccessToken(access_token);
            this.props.history.push('/');
        } catch (error) {
            this.props.showMessage({
                show: true,
                message: { type: 'error', text: error.data?.message || 'Internal Error' },
            });
        } finally {
            this.props.showLoader(false);
        }
    };

    render() {
        const { email, password } = this.state;
        const { isLoader } = this.props;
        return (
            <div className="app-login-wrapper">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 offset-lg-4 col-md-6 offset-md-3 col-sm-12 offset-sm-0 content border shadow">
                            <div className="logo text-center">
                                <img src="/images/logo/logo_green.png" alt="" />
                                <h2 className="mt-4 font-weight-bold">(Super Administrator)</h2>
                            </div>
                            <div className="form-group mb-4">
                                <label htmlFor="email">Email</label>
                                <TextBox
                                    tabIndex="0"
                                    id="email"
                                    name="email"
                                    type="text"
                                    validate={this.state.validate}
                                    value={email}
                                    placeholder="Email"
                                    onBlur={(e) => {}}
                                    onChange={(email, e) => {
                                        this.setState({
                                            email: email,
                                        });
                                    }}
                                    validationOption={{
                                        showMsg: false,
                                        name: 'Email',
                                        reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                        regMsg: 'Invalid Email',
                                        check: true,
                                        required: true,
                                    }}
                                />
                            </div>
                            <div className="form-group mb-4">
                                <label htmlFor="email">Password</label>
                                <TextBox
                                    tabIndex="0"
                                    id="password"
                                    name="password"
                                    type="password"
                                    validate={this.state.validate}
                                    value={password}
                                    placeholder="Password"
                                    onBlur={(e) => {}}
                                    onChange={(password, e) => {
                                        this.setState({
                                            password: password,
                                        });
                                    }}
                                    validationOption={{
                                        showMsg: false,
                                        name: 'Password',
                                        check: true,
                                        required: true,
                                    }}
                                />
                            </div>
                            <div className="form-group mt-4">
                                <Button
                                    color="primary"
                                    className="btn-primary btn btn-block btn-lg"
                                    onClick={this.signIn}
                                >
                                    Login
                                </Button>
                            </div>
                            <div className="text-center mt-3">
                                <Link to="/forgotpass">Forgot your password?</Link>
                            </div>
                            {isLoader && (
                                <div className="loader-view">
                                    <CircularProgress />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ user, ui }) => {
    const { authUser } = user;
    const { isLoader } = ui;
    return { isLoader, authUser };
};

export default connect(mapStateToProps, {
    showLoader,
    showMessage,
    putAccessToken,
    handleHTTPError,
})(Login);
